"use strict";
const planFormSelector = '.js-plan_form';
const planPreviewSelector = '.js-plan_preview';
const planCardSelector = '.js-plan_card_preview';
const fileInputSelector = `${planFormSelector} .js-file_upload_redesign`;
const deleteButtonSelector = `${planFormSelector} .js-file_upload_delete_button_redesign`;
const deleteImageInputSelector = `${planFormSelector} .js-file_upload_delete_image_input_redesign`;
window.up.on(document, 'up:form:validate', planFormSelector, event => {
    event.params.delete('plan[image]');
    // the edit form's hidden Phoenix _method=put field would otherwise make Plug.MethodOverride
    // turn this POST into a PUT, which has no matching /preview route
    event.params.delete('_method');
});
window.up.compiler('.js-plan_discount_period', period => {
    const toggle = period.querySelector('.js-plan_discount_period_toggle');
    if (!toggle)
        return;
    // The preview shows one period at a time. An edit to this period's offer selects it there,
    // and the change event lets Unpoly's up-switch show its card.
    const showPeriodInPreview = () => {
        const option = document.querySelector(toggle.dataset.previewPeriodOption);
        if (option && !option.checked) {
            option.checked = true;
            option.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };
    period.addEventListener('input', showPeriodInPreview);
    return () => {
        period.removeEventListener('input', showPeriodInPreview);
    };
});
const objectUrls = new WeakMap();
function objectUrlFor(file) {
    const cached = objectUrls.get(file);
    if (cached)
        return cached;
    const url = URL.createObjectURL(file);
    objectUrls.set(file, url);
    return url;
}
// The card only renders an <img> once the plan has a saved image, so for a plan
// without one there is nothing to write the chosen file into until we add it.
function buildPlanCardImage(card) {
    const img = document.createElement('img');
    img.className = 'plan_card__image';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    card.prepend(img);
    return img;
}
// The preview has one card per billing period the publication sells.
function syncPlanCardImages() {
    var _a, _b;
    const fileInput = document.querySelector(fileInputSelector);
    const deleteImageInput = document.querySelector(deleteImageInputSelector);
    const file = (_a = fileInput === null || fileInput === void 0 ? void 0 : fileInput.files) === null || _a === void 0 ? void 0 : _a[0];
    const deleting = (_b = deleteImageInput === null || deleteImageInput === void 0 ? void 0 : deleteImageInput.hasAttribute('name')) !== null && _b !== void 0 ? _b : false;
    document.querySelectorAll(planCardSelector).forEach(card => {
        const img = card.querySelector('img');
        const content = card.querySelector('.plan_card__content');
        if (file) {
            const preview = img || buildPlanCardImage(card);
            preview.src = objectUrlFor(file);
            preview.removeAttribute('srcset');
            content === null || content === void 0 ? void 0 : content.classList.remove('plan_card__content--no_image');
        }
        else if (deleting && img) {
            img.remove();
            content === null || content === void 0 ? void 0 : content.classList.add('plan_card__content--no_image');
        }
    });
}
window.up.compiler(planPreviewSelector, () => syncPlanCardImages());
window.up.on(document, 'change', fileInputSelector, () => syncPlanCardImages());
window.up.on(document, 'click', deleteButtonSelector, () => syncPlanCardImages());
